import React from 'react';
import Dialog from '../../../core/layout/Dialog';
import Button from '../../../core/form/Button';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import DateInput from '../../../core/form/DateInput';
import get from 'lodash/get';
import Separator from '../../../core/layout/Separator';

const ContractActivationDialog = (props) => (
  <Dialog
    title="Activate Contract"
    actions={[
      <Button label="Yes" type="danger" onClick={props.onConfirm} key="yes" />,
      <Button label="No" type="default" onClick={props.onCancel} key="no" />,
    ]}
    onCancel={props.onCancel}
    isOpen={props.isOpen}
  >
    <Row>
      <span>
        Are you sure you want to activate the contract {get(props.values, 'documentNumber')}? This action will activate
        all access to contract's distributor or contract's company, including admin users and students.
      </span>
    </Row>
    <Separator />
    <Row>
      <Column size={6}>
        <DateInput
          required
          label="Contract starts in"
          value={get(props.values, 'startsAt')}
          onChange={(value) => props.onChange('startsAt', value)}
          errorText={get(props.errors, 'startsAt', '')}
        />
      </Column>
      <Column size={6}>
        <DateInput
          label="Contracts ends in"
          value={get(props.values, 'endsAt')}
          onChange={(value) => props.onChange('endsAt', value)}
        />
      </Column>
    </Row>
  </Dialog>
);

ContractActivationDialog.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ContractActivationDialog.defaultProps = {
  isOpen: false,
  errors: {},
};

export default ContractActivationDialog;
